<!-- Pug Template -->
<template lang="pug">
.tech-company-index

	.introduction.mt-4.mb-4(
		v-if="introduction"
		v-html="introduction"
		data-in-view
	)

	.row
		.col-sm-6.d-flex.mb-4(
			v-for="stage in stages"
			:key="stage.id"
		)
			stage-card(
				:stage="stage"
				data-in-view
			)
		
		.col-sm-6.d-flex.mb-4(
			v-if="extraPanel"
		)
			.card.d-flex.w-100.p-5.py-4.align-items-center.text-center.extra-panel.rounded-lg(
				data-in-view
			)
				h2.h1 {{ extraPanel.title }}
				
				.flex-grow-1.card-text(
					v-html="extraPanel.text"
				)
				a.btn.btn-secondary.btn-lg.font-sans.btn-pill(
					:href="extraPanel.link.url"
					:target="extraPanel.link.target"
				) {{ extraPanel.link.title }}
					span.mdi.mdi-arrow-right.ml-2(
						style="font-size: inherit;"
					)


</template>

<!-- Script -->
<script>
import store from './store';
import StageCard from './StageCard.vue';
const $ = jQuery;
export default {
	components: {
		StageCard
	},
	computed: {
		stages(){
			return store.stages;
		},
		extraPanel(){
			return store.extraPanel;
		},
		introduction(){
			return store.introduction;
		}
	},
	data(){
		return {
			boxes: $('.tech-company-boxes').first()
		}
	},
	mounted(){
		this.boxes.addClass('d-none');
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss" scoped>
.extra-panel {
	border: 2px solid #000;
}
</style>